/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Export_StatusInputs */

const en_manual_qc_export_status = /** @type {(inputs: Manual_Qc_Export_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status`)
};

const fr_manual_qc_export_status = /** @type {(inputs: Manual_Qc_Export_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statut`)
};

const de_manual_qc_export_status = /** @type {(inputs: Manual_Qc_Export_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status`)
};

const it_manual_qc_export_status = /** @type {(inputs: Manual_Qc_Export_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stato`)
};

const ru_manual_qc_export_status = /** @type {(inputs: Manual_Qc_Export_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Статус`)
};

const es_manual_qc_export_status = /** @type {(inputs: Manual_Qc_Export_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estado`)
};

const zh_cn2_manual_qc_export_status = /** @type {(inputs: Manual_Qc_Export_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`地位`)
};

const ja_manual_qc_export_status = /** @type {(inputs: Manual_Qc_Export_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`状態`)
};

const hi_manual_qc_export_status = /** @type {(inputs: Manual_Qc_Export_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्थिति`)
};

const pt_pt2_manual_qc_export_status = /** @type {(inputs: Manual_Qc_Export_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status`)
};

/**
* | output |
* | --- |
* | "Status" |
*
* @param {Manual_Qc_Export_StatusInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_export_status = /** @type {((inputs?: Manual_Qc_Export_StatusInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Export_StatusInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_manual_qc_export_status(inputs)
	if (locale === "de") return de_manual_qc_export_status(inputs)
	if (locale === "it") return it_manual_qc_export_status(inputs)
	if (locale === "ru") return ru_manual_qc_export_status(inputs)
	if (locale === "es") return es_manual_qc_export_status(inputs)
	if (locale === "zh-CN") return zh_cn2_manual_qc_export_status(inputs)
	if (locale === "ja") return ja_manual_qc_export_status(inputs)
	if (locale === "hi") return hi_manual_qc_export_status(inputs)
	if (locale === "pt-PT") return pt_pt2_manual_qc_export_status(inputs)
	return en_manual_qc_export_status(inputs)
});